import React from 'react';
import Button from '@material-ui/core/Button';
import styled from "@emotion/styled";
//--------------------------------//
import colorPalette from "../../styles/theme/colorPalette";

const RoundedCornersButton = (props) => {

  const { label, isActive, handleFunc, width='128px' } = props

  return (
    <RoundedButton
        maincolor={ isActive ? colorPalette.primary : colorPalette.secondary }
        width={width}
        size={'large'}
        onClick={handleFunc}
    >
      <span>{ label }</span>
    </RoundedButton>
  )
}

export default RoundedCornersButton;

const RoundedButton = styled(Button)`
  margin: 0 12px;
  padding: 0px 16px;
  border-radius: 100px;
  border-style: solid;
  border-width: 1px;
  border-color: ${props => props.maincolor };
  color: ${props => props.maincolor };
  font-size: 24px;
  font-weight: bold;
  min-width: ${props => props.width };
`